import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShoppingCart } from 'lucide-react';
import { useCart } from '../../contexts/CartContext';
import { useTranslation } from 'react-i18next';

const CartIcon: React.FC = () => {
  const { count } = useCart();
  const navigate = useNavigate();
  const { t } = useTranslation();

  if (count === 0) return null;

  return (
    <button
      type="button"
      aria-label={t('pages.order.cart', { defaultValue: 'Carrito' })}
      onClick={() => navigate('/orden')}
      className="relative inline-flex items-center bg-blue-600 text-white px-3 py-2 rounded-full hover:bg-blue-700 transition-colors"
    >
      <ShoppingCart className="h-5 w-5" />
      <span className="ml-2 text-sm font-semibold">{count}</span>
    </button>
  );
};

export default CartIcon;
